import { Link } from 'react-router-dom'
import { ArrowLeft, Sparkles, Play, BookOpenCheck, FilmIcon, ArrowRight } from 'lucide-react'
import * as stylex from '@stylexjs/stylex'
import { styles } from '@/styles/WorkspacePage.stylex'
import { useState } from 'react'

export default function WorkspacePage() {
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    const additionalFeatures = [
        { title: "Explore Examples", description: "Explore Full Projects Examples created with AiBrush Studio.", icon: <BookOpenCheck size={20} />, href: "/examples" },
        { title: "Quick Start Guide", description: "Get up and running with AiBrush Studio in minutes.", icon: <Play size={20} />, href: "/quick-start" },
        { title: "Timeline Editor", description: "Explore the timeline editor and learn how to create and edit videos.", icon: <FilmIcon size={20} />, href: "/timeline" },
        { title: "AI Models", description: "Discover all available AI models and their capabilities.", icon: <Sparkles size={20} />, href: "/ai-models" }
    ]

    return (
        <div {...stylex.props(styles.workspacePage)}>
            <Link to="/" {...stylex.props(styles.backLink)}>
                <ArrowLeft size={20} />
                Back to Home
            </Link>

            <div {...stylex.props(styles.pageHeader)}>
                <div {...stylex.props(styles.headerContent)}>
                    <h1 {...stylex.props(styles.pageTitle)}>
                        <Sparkles size={32} {...stylex.props(styles.titleIcon)} />
                        Workspace
                    </h1>
                    <p {...stylex.props(styles.pageSubtitle)}>
                        Your creative hub for AI-powered media creation, INDEPENDENT of specific projects.
                    </p>
                </div>
            </div>

            <section {...stylex.props(styles.workspaceSection)}>
                <div {...stylex.props(styles.screenshotContainer)}>
                    <img
                        src="https://cdn.aibrush.co/docs/qstart/workspace-1.png"
                        alt="AiBrush Studio Workspace Interface"
                        {...stylex.props(styles.workspaceScreenshot)}
                    />
                </div>
            </section>

            <section {...stylex.props(styles.additionalFeaturesSection)}>
                <div {...stylex.props(styles.featuresGrid)}>
                    {additionalFeatures.map((feature, index) => (
                        <Link
                            key={index}
                            to={feature.href}
                            {...stylex.props(styles.featureCard)}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <div {...stylex.props(styles.featureIcon)}>{feature.icon}</div>
                            <div {...stylex.props(styles.featureContent)}>
                                <h3 {...stylex.props(styles.featureTitle)}>{feature.title}</h3>
                                <p {...stylex.props(styles.featureDescription)}>{feature.description}</p>
                            </div>
                            <ArrowRight
                                size={16}
                                {...stylex.props(
                                    styles.featureArrow,
                                    hoveredIndex === index && styles.featureArrowHover
                                )}
                            />
                        </Link>
                    ))}
                </div>
            </section>

            <section {...stylex.props(styles.ctaSection)}>
                <div {...stylex.props(styles.ctaContent)}>
                    <h2 {...stylex.props(styles.ctaTitle)}>Ready to Start Creating?</h2>
                    <p {...stylex.props(styles.ctaDescription)}>
                        Jump into your workspace and begin your AI-powered creative journey today.
                    </p>
                    <div {...stylex.props(styles.ctaButtons)}>
                        <Link to="https://aibrush.co/workspace" {...stylex.props(styles.primaryButton)}>
                            <Play size={16} />
                            Go to Workspace
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    )
}